// extracted by mini-css-extract-plugin
export default {"logoStyle":"Header_logoStyle__OECBB","headerBox":"Header_headerBox__Hq9im"};